import { render, staticRenderFns } from "./Tiempo_Libre.vue?vue&type=template&id=4c0bf015"
import script from "./Tiempo_Libre.vue?vue&type=script&lang=js"
export * from "./Tiempo_Libre.vue?vue&type=script&lang=js"
import style0 from "./Tiempo_Libre.vue?vue&type=style&index=0&id=4c0bf015&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports